module.exports = __webpack_public_path__ + "static/media/News-Schools.9bbbb89a.svg";